<template>
	<v-app-bar
		class="topBar"
		app
		scroll-off-screen
		color="white"
	>
		<v-btn
			v-show="showBackButton"
			icon
			@click="goBack"
		>
			<v-icon>mdi-arrow-left</v-icon>
		</v-btn>
		<v-spacer></v-spacer>

		<v-btn
			class="logo"
			icon
			@click="gotoHomeRoute"
		>
			<v-img
				height="38"
				width="114"
				src="@/assets/logo.png"
				contain
			/>
		</v-btn>
		<v-spacer></v-spacer>
		<v-btn
			icon
			@click="$emit('menu-button-click')"
		>
			<v-icon>mdi-menu</v-icon>
		</v-btn>
		<v-toolbar-title
			v-if="$route.meta && $route.meta.headline"
			slot="extension"
		>
			{{$route.meta.headline}}
		</v-toolbar-title>
	</v-app-bar>
</template>

<script>

export default {
	name: 'TopBar',
	computed: {
		showBackButton () {
			return this.$route.meta.prevRoute && Object.keys(this.$route.meta.prevRoute).length
		}
	},
	methods: {
		gotoHomeRoute () {
			const homeRoute = this.$router.options.routes.find(item => item.name == 'membershipCard')

			if (!homeRoute || this.$route.name == homeRoute.name) return

			this.$router.push({
				name: homeRoute.name,
			})
		},
		goBack () {
			if (!this.$route.meta.prevRoute || !Object.keys(this.$route.meta.prevRoute).length) return

			// Go back to the previous route
			this.$router.replace(this.$route.meta.prevRoute, (route) => {
				// If route has scrollY defined, scroll to that position
				this.$nextTick(() => {
					if (route.meta.scrollY) {
						window.scrollTo(0, route.meta.scrollY)
						route.meta.scrollY = 0
					} else {
						window.scrollTo(0, 0)
					}
				})
			})
		}
	}
}
</script>

<style lang="scss" scoped>

	.logo {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}

</style>